import { signalStore, type, withState } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';

import { withPagination } from '../../shared/store/pagination.feature';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { Certification } from '../models/certification';
import { avecMéthodesCertifications } from './certification.methods';
import { CertificationState, initialState } from './certification.state';

export const configCertification = entityConfig({
  entity: type<Certification>(),
  selectId: (certification) => certification.codeFiche,
});

export const CertificationStore = signalStore(
  { providedIn: 'root' },
  withState<CertificationState>(initialState),
  withEntities<Certification>(configCertification),
  withSelectedEntity(),
  withPagination<Certification>(),
  avecMéthodesCertifications(),
);
